import { useCandidateHeaderQuery } from "@generated/graphql";
import PageHeader from "components/PageHeader";
import useIsCreate from "hooks/useIsCreate";
import useSetTabTitle from "hooks/useSetTabTitle";
import { useParams } from "react-router-dom";

const Header = () => {
  const { candidateId } = useParams();
  const isCreate = useIsCreate();
  const { data } = useCandidateHeaderQuery({ variables: { candidateId: candidateId! }, skip: !candidateId });

  const candidate = data?.companyCandidate;

  const getCandidateTopic = () => {
    if (isCreate) return "";

    return [candidate?.numericId || "", candidate?.fullName || ""].filter((item) => item).join(", ");
  };

  const title = `Кандидат ${getCandidateTopic()}`;

  useSetTabTitle(title, candidate);

  return <PageHeader title={title} />;
};

export default Header;
